// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".formulate-input-errors{color:red}.extra-area .formulate-input-grouping .formulate-input-group-repeatable{display:flex}.extra-area .formulate-input-grouping .formulate-input-group-repeatable:not(:last-child){border-bottom:1px solid gray}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
